import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  className?: string;
}

export function FeatureCard({ title, description, icon: Icon, className }: FeatureCardProps) {
  return (
    <div className={cn('group/card card-kuiva text-center', className)}>
      <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-kuiva-blue/20 to-kuiva-green/20 transition-[transform,box-shadow] duration-500 ease-kuiva group-hover/card:-rotate-2 group-hover/card:scale-110 sm:h-14 sm:w-14 sm:rounded-2xl">
        <Icon className="h-6 w-6 text-kuiva-blue transition-transform duration-500 group-hover/card:scale-110 sm:h-7 sm:w-7" />
      </div>
      <h3 className="mb-1 text-sm font-semibold text-foreground sm:text-base">{title}</h3>
      <p className="text-xs leading-relaxed text-muted-foreground sm:text-sm">{description}</p>
    </div>
  );
}
